import EventBusConstants from '@/constants/EventBusConstants';
import PlayerEmitter from '@/event/PlayerEmitter';
import ScheduledTask from '@/task/ScheduledTask';
import IPauseManagerNotificationObserver from '../pause/IPauseManagerNotificationObserver';
import { PauseType, PauseState } from '../pause/PauseManager';
import IPersistenceEventHandler from '../persistence/IPersistenceEventHandler';
import PersistenceEventType from '../persistence/PersistenceEventType';
import TestController from '../TestController';
import IScheduledTaskState from './IScheduledTaskState';
import PausedState from './PausedState';
import RunningState from './RunningState';
import ScheduledTaskStateType from './ScheduledTaskStateType';

class ScheduledTaskManager implements IPersistenceEventHandler, IPauseManagerNotificationObserver {
  private scheduledTask: ScheduledTask | undefined = undefined;
  private readonly playerEmitter: PlayerEmitter;
  private readonly stateMap: Map<ScheduledTaskStateType, IScheduledTaskState> = new Map<
    ScheduledTaskStateType,
    IScheduledTaskState
  >();

  private state: IScheduledTaskState | undefined;

  constructor(testController: TestController, playerEmitter: PlayerEmitter) {
    this.stateMap.set(ScheduledTaskStateType.RUNNING, new RunningState(this, testController));
    this.stateMap.set(ScheduledTaskStateType.PAUSED, new PausedState(this, testController));
    this.playerEmitter = playerEmitter;
    this.updateState(ScheduledTaskStateType.PAUSED);
  }

  updateState(type: ScheduledTaskStateType) {
    this.state = this.stateMap.get(type);
    this.state?.handleEvent();
  }

  createScheduler() {
    if (!this.scheduledTask) {
      this.scheduledTask = new ScheduledTask(
        20000,
        () => {
          return true;
        },
        () => {
          this.playerEmitter.emit(EventBusConstants.SCHEDULED_EVENT, [['type', 'saveRequest']]);
        }
      );
    }
  }

  clearScheduler() {
    if (this.scheduledTask) {
      this.scheduledTask.cancelScheduler();
      this.scheduledTask = undefined;
    }
  }

  handleEvent(): void {
    this.state?.handleEvent();
  }

  // IPersistenceEventHandler
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  persistenceEvent(type: PersistenceEventType) {
    this.handleEvent();
  }

  // IPauseManagerNotificationObserver
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pauseStateNotification(type: PauseType, state: PauseState) {
    this.handleEvent();
  }

  // IPauseManagerNotificationObserver
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pauseError(error: Error) {
    this.handleEvent();
  }
}

export default ScheduledTaskManager;
